var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("reconciliation-step-template", {
    attrs: {
      nextStep: _vm.nextStep,
      previousStep: _vm.previousStep,
      loading: _vm.loading
    },
    on: {
      previous: function($event) {
        return _vm.$emit("previous")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h2", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Visualisation de votre fichier CSV")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3 gray-80 mt-2 mb-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Vérifiez les données ci-dessous, elles serviront à créer votre relevé bancaire compatible avec Sellsy."
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3 gray-80 mt-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Si le fichier contient des erreurs, il vous faudra modifier vos paramètres."
                    )
                  ) +
                  "\n        "
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "step-container-table border-black"
              },
              [
                _c("table-selectable-columns", {
                  attrs: { lines: _vm.csv, selectable: false, format: "object" }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "aright" },
              [
                _vm.previousStep
                  ? _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "bankreconciliation.importsteps.ReconciliationStep6.modify_parameters"
                        ),
                        type: "secondary",
                        disabled: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("next", "bankreconciliation-step2")
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__(
                      "bankreconciliation.importsteps.ReconciliationStep6.save_and_continue"
                    ),
                    type: "primary",
                    disabled: !_vm.importAllowed || _vm.loading
                  },
                  on: { click: _vm.goToNextStep }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }